function toggleRecoverForm() {
    var isRecover = window.location.hash === '#recover';
    var loginForm = document.querySelector('[data-login-form]');
    var recoverForm = document.querySelector('[data-recover-form]');
    var successMsg = document.querySelector('[data-reset-success]');

    if (isRecover) {
      loginForm.classList.add('hide');
      recoverForm.classList.remove('hide');
      // Show success message if the form was just submitted
      if (document.querySelector('[data-form-state]')) {
        successMsg.classList.remove('hide');
      }
    } else {
      loginForm.classList.remove('hide');
      recoverForm.classList.add('hide');
    }
  }

  // Run on page load
  window.addEventListener('load', toggleRecoverForm);
  // Run if the hash changes without a page refresh
  window.addEventListener('hashchange', toggleRecoverForm);